import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';

const PHONE_NUMBER = '971554688022';

const DEFAULT_MESSAGE = encodeURIComponent(
  'Hello Jisr Al Sahra Plaster & Tiles Cont. I would like to request a quotation for my project.'
);

const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37,211,102,.45);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 12px rgba(37,211,102,0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37,211,102,0);
  }
`;

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
`;

const Wrapper = styled.div`
  position: fixed;
  right: 32px;
  bottom: 90px; /* Sits nicely above BackToTop button */
  z-index: 9999;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transform: ${({ $visible }) =>
    $visible ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.35s ease;

  @media (max-width: 768px) {
    right: 20px;
    bottom: 80px;
  }

  @media (max-width: 480px) {
    right: 16px;
    bottom: 72px;
  }
`;

const ChatButton = styled.button`
  /* Standardized compact dimensions for all screen sizes */
  width: 46px;
  height: 46px;
  border: none;
  outline: none;
  border-radius: 50%;
  background: #25d366;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.35);
  animation: ${pulse} 2.2s infinite;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background: #1ebe5d;
    transform: translateY(-3px);
    animation: ${bounce} 0.6s;
  }

  &:active {
    transform: scale(0.92);
  }

  /* Compact sizes maintained across breakpoints */
  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
  }

  @media (max-width: 480px) {
    width: 42px;
    height: 42px;
  }
`;

const WhatsAppIcon = styled(FaWhatsapp)`
  font-size: 1.55rem;

  @media (max-width: 768px) {
    font-size: 1.45rem;
  }

  @media (max-width: 480px) {
    font-size: 1.35rem;
  }
`;

const Tooltip = styled.div`
  position: absolute;
  right: 58px;
  top: 50%;
  transform: translateY(-50%);
  background: #111827;
  color: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: all 0.25s ease;

  &::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    border-left: 5px solid #111827;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  ${ChatButton}:hover & {
    opacity: 1;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export default function ChatNow() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 250);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleChatClick = () => {
    window.open(
      `https://wa.me/${PHONE_NUMBER}?text=${DEFAULT_MESSAGE}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Wrapper $visible={visible}>
      <ChatButton
        onClick={handleChatClick}
        aria-label="Chat with us on WhatsApp"
        title="WhatsApp"
      >
        <Tooltip>Chat with us</Tooltip>
        <WhatsAppIcon />
      </ChatButton>
    </Wrapper>
  );
}